import React from 'react';
import { M130ProductDetailModule } from '~/lib/data-contract';
import { ModuleFeatureContext } from '~/templates/blocks/context/ModuleFeatureContext';
import ProductDetails from './product-details.component';

const M130ProductDetail = (props: M130ProductDetailModule) => {
    return (
        <ModuleFeatureContext.Provider value={{ reserveInStore: false }}>
            <ProductDetails {...props} />
        </ModuleFeatureContext.Provider>
    );
};

export default M130ProductDetail;